var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Status Updates")]),_c('v-data-table',{staticStyle:{"width":"100%"},attrs:{"headers":_vm.headers,"items":_vm.statusUpdates,"item-key":"index","dense":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(item.createdAt,"MM/DD/YYYY"))+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }